import Icon from '../components/Icon.vue'

Icon.register({
  'grin-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM311.7 136.7c-12.4 18.4-15.2 36.9-15.7 55.3 0.6 18.4 3.3 36.9 15.7 55.3 8 11.7 25.1 11.4 32.7 0 12.4-18.4 15.2-36.9 15.7-55.3-0.6-18.4-3.3-36.9-15.7-55.3-8-11.7-25.1-11.4-32.7 0zM151.7 136.7c-12.4 18.4-15.2 36.9-15.7 55.3 0.6 18.4 3.3 36.9 15.7 55.3 8 11.7 25.1 11.4 32.7 0 12.4-18.4 15.2-36.9 15.7-55.3-0.6-18.4-3.3-36.9-15.7-55.3-8-11.7-25.1-11.4-32.7 0zM248 432c60.6 0 134.5-38.3 143.8-93.3 1.9-11.8-9.3-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.4-3.7-22.7 6.1-20.7 17.9 9.3 55 83.2 93.3 143.8 93.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-alt.js
// module id = 1402
// module chunks = 0